var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("sfe.appVersion.BoxWrap.manage") },
        },
        [
          _c(
            "div",
            { staticClass: "content-wrap" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-between" } },
                [
                  _c(
                    "el-col",
                    { staticClass: "content-item", attrs: { span: 22 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("img", {
                              staticClass: "platform-icon",
                              attrs: {
                                src: require("@/assets/setting/apple.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("img", {
                              staticClass: "Biz-icon",
                              attrs: {
                                src: require("@/assets/setting/logo.png"),
                                alt: "",
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "p",
                              {
                                staticClass: "version-wrap",
                                class:
                                  _vm.currentVersion("IOS", "SFE")
                                    .versionStatus === "DRAF"
                                    ? "can-release"
                                    : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.releaseVersion("IOS", "SFE")
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "version sfe" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currentVersion("IOS", "SFE")
                                        .displayVersion
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.currentVersion("IOS", "SFE")
                                  .versionStatus === "DRAF"
                                  ? _c("svg-icon", {
                                      staticClass: "draft-icon",
                                      attrs: { "icon-class": "releases" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "FPermission",
                                      rawName: "v-FPermission",
                                      value: {
                                        pageName: _vm.pageName,
                                        list: ["ADD_EDIT"],
                                      },
                                      expression:
                                        "{pageName, list: ['ADD_EDIT']}",
                                    },
                                  ],
                                  attrs: { type: "sfe", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addVersion("IOS", "SFE")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "sfe.appVersion.button.changeVersion"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "FPermission",
                                      rawName: "v-FPermission",
                                      value: {
                                        pageName: _vm.pageName,
                                        list: ["ADD_EDIT"],
                                      },
                                      expression:
                                        "{pageName, list: ['ADD_EDIT']}",
                                    },
                                  ],
                                  attrs: { type: "sfe", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clearCache()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("sfe.appVersion.button.clearCache")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            "is-show": _vm.isShowHisModel,
            "dialog-status": _vm.$t("sfe.appVersion.table.hisList"),
            "is-only-confirm": true,
            width: "800px",
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowHisModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowHisModel = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.hisList,
                border: "",
                stripe: "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "displayVersion",
                  label: _vm.$t("sfe.appVersion.table.displayVersion"),
                  align: "left",
                  width: "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "versionDesc",
                  label: _vm.$t("sfe.appVersion.table.versionDesc"),
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "downloadUrl",
                  label: _vm.$t("sfe.appVersion.table.downloadUrl"),
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lastUpdateTime",
                  label: _vm.$t("sfe.appVersion.table.lastUpdateTime"),
                  align: "center",
                  width: "140",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("sfe.appVersion.table.createTime"),
                  align: "center",
                  width: "140",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("CreateModel", {
        attrs: {
          "dialog-status": _vm.dialogStatus,
          "is-show": _vm.isShowModel,
          brand: _vm.currBrand,
        },
        on: {
          "update:isShow": function ($event) {
            _vm.isShowModel = $event
          },
          "update:is-show": function ($event) {
            _vm.isShowModel = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }